<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <div v-if="!loading">
        <transition name="fade" mode="out-in" appear :duration="500">
          <keep-alive exclude="CoverSummaryReview">
            <component
              v-bind:is="current"
              @to-personal-details-review="toPersonalDetailsReview"
              @to-switch-cover="toSwitchCover"
              @to-vehicle-details-review="toVehicleDetailsReview"
              @to-policy-review="toPolicyReview"
              @cover-summary-review="toCoverSummaryReview"
              @to-switch-cover-review="toSwitchCoverReview"
              @to-branch-selection-review="toBranchSelectionReview"
              @to-payment-selection="toPaymentSelection"
              @to-valuer-selection="toValuerSelection"
              @to-make-payment="makePayment"
              v-bind="{...results, coverType : this.coverType }"
            ></component>
          </keep-alive>
        </transition>
      </div>
      <v-card v-else class="tw-w-full tw-flex tw-justify-center tw-p-10">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-card>
      <v-dialog v-model="showRegistrationPopup" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Client Registration</span>
          </v-card-title>
          <v-card-text>
            <v-form
              @submit.prevent="handleRegistration"
              ref="form"
              v-model="valid"
            >
              <v-text-field
                label="Name"
                v-model="registrationForm.name"
                :rules="[(v) => !!v || 'Name is required']"
                required
              ></v-text-field>
              <v-text-field
                label="Email"
                v-model="registrationForm.email"
                :rules="[
                  (v) => !!v || 'E-mail is required',
                  (v) => /^[^@]+@[^.]+\..+$/.test(v) || 'E-mail must be valid',
                ]"
                type="email"
                required
              ></v-text-field>
              <v-btn
                type="submit"
                color="primary"
                :loading="isRegistering"
                :disabled="!valid"
                >Register</v-btn
              >
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import PolicyReview from '@/components/policies/PolicyReview';
import PersonalDetailsReview from '@/components/policies/PersonalDetailsReview';
import VehicleDetailsReview from '@/components/policies/VehicleDetailsReview';
import BranchSelectionReview from '@/components/policies/BranchSelectionReview';
import MakePayment from '@/components/renew/MakePayment';
import PaymentSelection from '@/components/renew/PaymentSelection';
import SelectOption from '@/components/policies/SelectOption';
import SwitchCover from '@/components/policies/SwitchCover';
import CoverSummaryReview from '@/components/policies/CoverSummaryReview';
import SwitchCoverReview from '@/components/policies/SwitchCoverReview';

import ValuerSelection from '@/components/policies/ValuerSelection';
import renewalMixin from '@/mixins/renewalMixin';
import { FB_RENEW_IT } from '@/utils/const';

export default {
  name: 'RenewPolicy',
  components: {
    BreadCrumb,
    Default,
    PersonalDetailsReview,
    PolicyReview,
    VehicleDetailsReview,
    BranchSelectionReview,
    MakePayment,
    PaymentSelection,
    ValuerSelection,
    SelectOption,
    SwitchCover,
    CoverSummaryReview,
    SwitchCoverReview,
  },
  data: (vm) => ({
    breadcrumbs: [
      {
        text: 'My Policies',
        disabled: false,
        to: { name: 'MyPolicies' },
      },
      {
        text: 'My Policy',
        disabled: false,
        to: {
          name: 'SinglePolicy',
          params: { policyNo: vm.$route.params.policyNo },
        },
      },
      {
        text: 'Renew Policy',
        disabled: true,
        to: {
          name: 'RenewPolicy',
          params: { policyNo: vm.$route.params.policyNo },
        },
      },
    ],
    current: PersonalDetailsReview,
    data: {},
    policyNo: '',
    loading: true,
    vehicleData: {},
    branchData: {},
    paymentData: {},
    personalData: {},
    switchCoverData: {},
    summaryData: {},
    showRegistrationPopup: false,
    customerId: null,
    registrationForm: {
      name: '',
      email: '',
    },
    isRegistering: false,
    valid: false,
  }),
  computed: {
    results() {
      if (
        this.current === BranchSelectionReview
        || this.current === 'BranchSelectionReview'
        || this.current === PolicyReview
        || this.current === 'PolicyReview'
        || this.current === SwitchCover
        || this.current === 'SwitchCover'
        || this.current === CoverSummaryReview
        || this.current === 'CoverSummaryReview'
        || this.current === PaymentSelection
        || this.current === 'PaymentSelection'
        || this.current === SwitchCoverReview
        || this.current === 'SwitchCoverReview'
        || this.current === ValuerSelection
        || this.current === 'ValuerSelection'
      ) {
        return { renewal: this.data };
      }
      if (
        this.current === VehicleDetailsReview
        || this.current === 'VehicleDetailsReview'
      ) {
        return {
          renewal: this.data.data,
          switchedCover: this.data.switchedCover,
        };
      }
      if (
        this.current === PersonalDetailsReview
        || this.current === 'PersonalDetailsReview'
      ) {
        return { changeCover: this.data };
      }
      if (
        this.current === MakePayment
        || this.current === 'MakePayment'
      ) {
        return this.data;
      }
      return this.data;
    },
    quote() {
      return this.$store.getters['renewal/fetchQoute'];
    },
  },
  mounted() {
    this.initCoverType(this.$route.params.policyNo);
    this.$root.$on('nav-back-to', (data) => {
      if (data.currentTab === 'PaymentSelection') {
        this.data = this.paymentData;
      } else if (data.currentTab === 'BranchSelectionReview') {
        this.data = this.branchData;
      } else if (data.currentTab === 'VehicleDetailsReview') {
        this.data = this.vehicleData;
      } else if (data.currentTab === 'PolicyReview') {
        this.data = this.policyData;
      } else if (data.currentTab === 'PersonalDetailsReview') {
        this.data = this.personalData;
      } else if (data.currentTab === 'SwitchCover') {
        this.data = this.switchCoverData;
      } else if (data.currentTab === 'CoverSummaryReview') {
        this.data = this.summaryData;
      } else if (data.currentTab === 'SwitchCoverReview') {
        this.data = this.summaryData;
      } else if (data.currentTab === 'SelectOption') {
        this.data = {};
      }
      this.current = data.currentTab;
    });

    this.policyNo = this.$route.params.policyNo;
    this.$store
      .dispatch('renewal/fetchRenewalClient', this.$route.params.batchNo)
      .then(() => {
        this.$store
          .dispatch('getPolicy', this.$route.params.policyNo)
          .then(() => {
            this.loading = false;

            // Check for payment callback status from URL
            const status = this.$route.query.status;
            if (status === 'success' || status === 'cancelled') {
              // Reconstruct the data structure that MakePayment expects
              const renewalData = JSON.parse(localStorage.getItem('renewalData') || '{}');
              const personalData = JSON.parse(localStorage.getItem('personalData') || '{}');

              const renewal = {
                premiumAfterTax: renewalData.premiumAfterTax,
                premiumInstalments: renewalData.premiumInstalments || [],
              };

              const distribution = localStorage.getItem('distribution') || '100';
              let percentage = distribution === '100' ? 100 : 40;
              if (this.coverType?.coverTypeId === 121) {
                percentage = 100;
              }

              const payment = {
                payableAmount:
                  this.coverType?.coverTypeId === 120 && renewal.premiumInstalments.length > 0
                    ? renewal.premiumInstalments[0].premium
                    : renewal.premiumAfterTax,
                kraPin: personalData.kraPinNumber || '',
                accountReference: renewalData.vehicle?.regNo || '',
                description: this.$route.params.batchNo ? `ren-${this.$route.params.batchNo}` : '',
                customerPhoneNumber: personalData.mobileNo || '',
                serviceType: 'MOTOR',
                transactionType: 'PAYMENT',
              };

              const quoteInfo = {
                coverType: this.coverType,
                payPercentage: percentage,
                client: personalData,
                pageTitle: '',
                freeBenefits: renewalData.freeBenefits || [],
              };

              this.data = {
                ...renewal,
                data: { payment, quoteInfo },
              };

              this.current = MakePayment;
            }
          });
      });

    this.$analytics.logEvent(FB_RENEW_IT, { product: 'Renewal Journey' });
    this.policyNo = this.$route.params.policyNo;
  },
  mixins: [renewalMixin],
  methods: {
    toSwitchCover(data) {
      this.data = data;
      this.switchCoverData = data;
      this.current = SwitchCover;
    },
    toPersonalDetailsReview(data) {
      this.data = data;
      this.personalData = data;
      this.current = PersonalDetailsReview;
    },
    toVehicleDetailsReview(data) {
      this.data = {
        ...data,
        personalData: data.personalData,
      };
      this.vehicleData = data;
      this.current = VehicleDetailsReview;
    },
    toPolicyReview(responseData) {
      this.data = {
        ...this.data,
        policyData: responseData,
      };
      this.policyData = responseData;
      this.current = PolicyReview;
    },

    toCoverSummaryReview(data) {
      this.data = data;
      this.summaryData = data;
      this.current = CoverSummaryReview;
    },
    toSwitchCoverReview(data) {
      this.data = data;
      this.summaryData = data;
      this.current = SwitchCoverReview;
    },
    toBranchSelectionReview(data) {
      this.data = data;
      this.branchData = data;
      this.current = BranchSelectionReview;
    },
    toPaymentSelection(batchId) {
      this.data = { getQuote: this.quote, batchId };
      this.paymentData = { getQuote: this.quote, batchId };
      this.current = PaymentSelection;
    },
    toValuerSelection(data) {
      this.data = data;
      this.current = ValuerSelection;
    },
    makePayment(data) {
      this.data = data;
      this.current = MakePayment;
    },
  },
  metaInfo: {
    title: 'Renew Policy',
  },
};
</script>
